import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import { Save } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  FormControl,
  LinearProgress,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import tests from 'Api/tests';

const EditSampleRate = ({ cancel, value, testId, reFetchProject }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const { handleSubmit, register, formState, errors } = useForm();

  const onSubmit = (data) => {
    setIsLoading(true);
    tests
      .setSampleRate({
        testId: testId,
        sampleRate: data.smapleRate,
      })
      .then(() => {
        reFetchProject();
        cancel();
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const renderForm = () => {
    if (!isLoading) {
      return (
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl fullWidth>
            <TextField
              variant="outlined"
              fullWidth
              label="Sample Rate (L/min)"
              defaultValue={value !== 'null' ? value : ''}
              {...register('smapleRate')}
              error={!!(errors && errors.smapleRate)}
              helperText={errors?.smapleRate?.message}
            />
          </FormControl>
          <Stack direction="row" justifyContent="space-between" mt={2}>
            <Button
              variant="contained"
              startIcon={<Save />}
              disabled={!formState.isDirty}
              type="submit"
            >
              Save
            </Button>
            <ButtonGroup>
              <Button onClick={cancel}>Cancel</Button>
            </ButtonGroup>
          </Stack>
        </form>
      );
    }
    return null;
  };

  return (
    <Stack p={2} spacing={2}>
      {isLoading && <LinearProgress />}
      <Typography variant="h5">Edit sample rate</Typography>
      <Box py={2}>{renderForm()}</Box>
      {!!error && (
        <Alert severity="error">Error when updating the sample type</Alert>
      )}
    </Stack>
  );
};

export default EditSampleRate;
